import React from 'react';

import QR from 'qrcode.react';
import { connect } from 'react-redux';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import PairSuccess from '../components/PairSuccess';
import AppDownload from '../components/AppDownload';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import {
  fetchFeaturedPlaylist,
  fetchHomePlaylist,
  fetchActivePlaylist,
  fetchMyPlaylist,
  fetchFollowedCollection,
} from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
// import { set4kQuality, setMute, setQR } from '../store/actions/settingActions';
import { BACK, ENTER, LEFT, RIGHT, UP, DOWN } from '../util/remoteButtons';
import { fireAnalytics } from './utils';

export class Pair extends React.Component {
  constructor(props) {
    super(props);
    // this.selectedBtn = 'android';
    this.android = React.createRef();
    this.ios = React.createRef();
    this.skip = React.createRef();
    this.pairInterval = null;

    this.state = {
      openDownloadApp: false,
      openSuccess: false,
      selectedBtn: 'skip',
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.closeAppDownload = this.closeAppDownload.bind(this);
    this.skipToCollection = this.skipToCollection.bind(this);
  }

  async componentDidMount() {
    fireAnalytics('Page', 'Pair Page Loaded');
    // let pairInterval = null;
    // var skipButton = this.refs.skipButton;
    setTimeout(() => {
      this.skip.current.focus();
    }, 200);

    let PID = localStorage.getItem('playlistID');
    if (PID === null) PID = '9363149b-09a6-48c6-a1d0-6ba28bfd4e7a';
    const pair = async () => {
      try {
        const deviceResult = await this.props.fetchDevice(this.props.app.LGDeviceId);
        if (deviceResult.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        console.log('Result : ', deviceResult);
        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          // this.props.updateQuality(deviceResult.payload.highQuality);
          // this.props.updateMute(deviceResult.payload.mute);
          // this.props.updateQR(deviceResult.payload.qr);
          clearInterval(this.pairInterval);
          const emailId = deviceResult.payload.email;
          const { userId } = deviceResult.payload;
          fireAnalytics('Pair', 'App Paired', emailId);
          await this.props.mobileDeviceId(userId);
          // TODO: Move this into a redux action. Functionality is duplicated on the splash page.
          // if (!bdAuth.getToken()) {
          const response = await bdReq.post('/emailLogin', { emailId });
          if (response.success) {
            bdAuth._storeToken(response.body);
          }

          // add playlist to follower
          // var emailId = 'lg-oled@blackdove.com';
          const playlistResponse = await bdReq.post('/v2/collections/9363149b-09a6-48c6-a1d0-6ba28bfd4e7a/followers', {
            userId,
          });
          console.log('playlistResponse', playlistResponse);
          if (playlistResponse.success) console.log('Response : ', playlistResponse);
          else console.log('Failed to follow playlist');
          // }

          const fetchUser = await this.props.fetchUser();
          if (fetchUser.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('user', fetchUser);
          const fetchSubscription = await this.props.fetchSubscription();
          if (fetchSubscription.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('fetchSubscription', fetchSubscription);
          const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
          if (fetchFeaturedPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('fetchFeaturedPlaylist', fetchFeaturedPlaylist);
          const fetchMyPlaylist = await this.props.fetchMyPlaylist();
          if (fetchMyPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('fetchMyPlaylist', fetchMyPlaylist);
          const fetchHomePlaylist = await this.props.fetchHomePlaylist();
          if (fetchHomePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('fetchHomePlaylist', fetchHomePlaylist);
          const fetchFollowedCollection = await this.props.fetchFollowedCollection();
          if (fetchFollowedCollection.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('fetchFollowedCollection', fetchFollowedCollection);
          const fetchActivePlaylist = await this.props.fetchActivePlaylist('9363149b-09a6-48c6-a1d0-6ba28bfd4e7a');
          if (fetchActivePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          console.log('fetchActivePlaylist', fetchActivePlaylist);
          clearInterval(this.onlineStatusInterval);
          this.setState({
            openSuccess: true,
          });

          setTimeout(() => {
            this.props.history.push('/playlist/9363149b-09a6-48c6-a1d0-6ba28bfd4e7a');
          }, 2000);
        }
      } catch (e) {
        // console.log(e);
      }
    };

    this.pairInterval = setInterval(() => pair(), 3000);

    // setTimeout(() => {
    // this.android.current.focus();
    // }, 1000);

    return () => {
      clearInterval(this.pairInterval);
    };
  }

  handleKeyDown(e) {
    e.stopPropagation();
    switch (e.which) {
      case UP:
        if (this.state.selectedBtn === 'skip') {
          this.android.current.focus();
          this.setState({
            selectedBtn: 'android',
          });
        }
        break;
      case DOWN:
        if (this.state.selectedBtn === 'android' || this.state.selectedBtn === 'ios') {
          this.skip.current.focus();
          this.setState({
            selectedBtn: 'skip',
          });
        }
        break;
      case RIGHT:
        if (this.state.selectedBtn === 'android') {
          this.ios.current.focus();
          this.setState({
            selectedBtn: 'ios',
          });
        }
        break;
      case LEFT:
        if (this.state.selectedBtn === 'ios') {
          this.android.current.focus();
          this.setState({
            selectedBtn: 'android',
          });
        }
        break;
      case ENTER:
        if (this.state.selectedBtn === 'skip') {
          clearInterval(this.pairInterval);
          this.skipToCollection(e);
        } else {
          this.android.current.blur();
          this.ios.current.blur();
          this.setState({
            openDownloadApp: true,
          });
        }

        break;
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        break;
    }
  }

  async skipToCollection(e) {
    e.preventDefault();
    e.stopPropagation();
    try {
      const emailId = 'lg-oled@blackdove.com';
      const response = await bdReq.post('/emailLogin', { emailId });
      if (response.success) {
        console.log(response);
        bdAuth._storeToken(response.body);
      }
      const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
      if (fetchFeaturedPlaylist.type === 'FETCH_FEATURED_PLAYLIST_FAILURE') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      } if (fetchFeaturedPlaylist.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      const fetchHomePlaylist = await this.props.fetchHomePlaylist();
      if (fetchHomePlaylist.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      const fetchMyPlaylist = await this.props.fetchMyPlaylist();
      if (fetchMyPlaylist.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      setTimeout(() => {
        this.props.history.push('/featured');
      }, 10);
    } catch (e) {
      console.log(e);
    }
  }

  closeAppDownload() {
    if (this.state.selectedBtn === 'android') this.android.current.focus();
    else this.ios.current.focus();
    setTimeout(() => {
      this.setState({
        openDownloadApp: false,
      });
    }, 0);
  }

  render() {
    console.log(this.state.openDownloadApp);
    return (
      <React.Fragment>
        {this.state.openSuccess && <PairSuccess />}
        {this.state.openDownloadApp && (
          <AppDownload
            selectedBtn={this.state.selectedBtn}
            closeAppDownload={this.closeAppDownload}
            props={this.props}
          />
        )}

        <div className="pair">
          <div
            className="pair__header"
            style={{
              height: window.innerWidth <= window.innerHeight ? '120px' : '95px',
            }}
          >
            <img
              className="pair__header__logo"
              src="assets/img/blackdove-logo-2020.png"
              alt=""
              style={{
                height: window.innerWidth <= window.innerHeight ? '35px' : '31px',
              }}
            />
            <p className="pair__header__text">digital canvas</p>
          </div>

          <p className="pair__quickStart" style={{ marginTop: window.innerWidth <= window.innerHeight ? '16%' : '6%' }}>
            Quick Start Guide
          </p>

          <div
            style={{
              display: 'flex',
              flexDirection: window.innerWidth <= window.innerHeight ? 'column' : 'row',
              margin: window.innerWidth > window.innerHeight && 'auto',
            }}
          >
            <div
              className="pair__box"
              style={{
                width: window.innerWidth <= window.innerHeight ? '78%' : '31%',
              }}
            >
              <div
                className="pair__box__textbox"
                style={{
                  fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.55rem',
                }}
              >
                <p
                  className="pair__box__textbox__no"
                  style={{ width: window.innerWidth <= window.innerHeight ? '10%' : '15%' }}
                >
                  1
                </p>
                <p className="pair__box__textbox__text">Download and sign up on the Blackdove app</p>
              </div>
              <p className="pair__box__text">
                Blackdove’s mobile app is the management tool for browsing new artwork, building collections and
                selecting works for display on your Digital Canvas.
              </p>
              <div className="pair__box__btns">
                <button
                  className="pair__box__btns__androidIos"
                  style={this.state.selectedBtn === 'android' ? { border: '4px solid #910048' } : null}
                  ref={this.android}
                  onKeyDown={this.handleKeyDown}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      openDownloadApp: true,
                      selectedBtn: 'android',
                    });
                  }}
                >
                  <div className="pair__box__btns__androidIos__icon">
                    <img className="" src="assets/img/android-icon.svg" alt="" />
                  </div>
                  <div
                    className="pair__box__btns__androidIos__text"
                    style={{
                      fontSize: window.innerWidth <= window.innerHeight ? '1.5rem' : '1.2rem',
                    }}
                  >
                    Get the android app
                  </div>
                </button>
                <button
                  className="pair__box__btns__androidIos"
                  style={this.state.selectedBtn === 'ios' ? { border: '6px solid #910048' } : null}
                  ref={this.ios}
                  onKeyDown={this.handleKeyDown}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      openDownloadApp: true,
                      selectedBtn: 'ios',
                    });
                  }}
                >
                  <div className="pair__box__btns__androidIos__icon">
                    <img className="" src="assets/img/ios-icon.svg" alt="" />
                  </div>
                  <div
                    className="pair__box__btns__androidIos__text"
                    style={{
                      fontSize: window.innerWidth <= window.innerHeight ? '1.5rem' : '1.2rem',
                    }}
                  >
                    Get the ios app
                  </div>
                </button>
              </div>
            </div>

            <div
              className="pair__box"
              style={{
                backgroundColor: '#222',
                marginTop: '20px',
                width: '100%',
                padding: window.innerWidth <= window.innerHeight ? '60px 11%' : '40px 2%',
                width: window.innerWidth <= window.innerHeight ? '100%' : '33%',
              }}
            >
              <div
                className="pair__box__textbox"
                style={{
                  fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.55rem',
                }}
              >
                <p
                  className="pair__box__textbox__no"
                  style={{ width: window.innerWidth <= window.innerHeight ? '10%' : '15%' }}
                >
                  2
                </p>
                <p className="pair__box__textbox__text">Pair your display using the Blackdove app on your mobile</p>
              </div>
              <div className="pair__box__container">
                <div className="pair__box__container__instructions">
                  <p>
                    1. Tap the icon <img style={{ margin: '-4px 5px' }} src="assets/img/tv-icon.svg" alt="" /> in the
                    app
                  </p>
                  <p>2. Add a new display</p>
                  <p>3. Scan the QR code on the left</p>
                </div>
                <div
                  className="pair__box__container__qrcode"
                  style={{ height: window.innerWidth <= window.innerHeight ? 280 : 230 }}
                >
                  <QR
                    className=""
                    value={this.props.app.LGDeviceId}
                    size={window.innerWidth <= window.innerHeight ? 250 : 200}
                    renderAs="svg"
                  />
                  {/* <img className="pair__box__container__qrcode__logo" src="assets/img/red-logo.svg" alt="" /> */}
                </div>
              </div>
            </div>

            <div
              className="pair__box"
              style={{
                width: window.innerWidth <= window.innerHeight ? '78%' : '31%',
              }}
            >
              <div
                className="pair__box__textbox"
                style={{
                  fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.55rem',
                }}
              >
                <p
                  className="pair__box__textbox__no"
                  style={{ width: window.innerWidth <= window.innerHeight ? '10%' : '15%' }}
                >
                  3
                </p>
                <p className="pair__box__textbox__text">It’s time to play art</p>
              </div>
              <p className="pair__box__text">
                From within your Blackdove app, select an artwork and press{' '}
                <img style={{ margin: '-7px 5px' }} src="assets/img/play-icon.svg" alt="" />
              </p>
            </div>
          </div>
          <div
            ref={this.skip}
            tabIndex="0"
            className="btn btn--round btn--block btn--dark info__btn pull-left "
            style={{
              background: '#910048',
              width: window.innerWidth <= window.innerHeight ? '35%' : '20%',
              marginBottom: window.innerWidth <= window.innerHeight ? '2%' : '',
              fontSize: '1.8rem',
            }}
            onKeyDown={this.handleKeyDown}
            onClick={(e) => {
              this.setState({
                selectedBtn: 'skip',
              });
              this.skipToCollection(e);
            }}
          >
            Skip to LG Collection
          </div>
          <div
            className="pair__footer"
            style={{
              height: window.innerWidth <= window.innerHeight ? '120px' : '95px',
              fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.5rem',
            }}
          >
            For help contact: <strong>support@blackdove.com</strong>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchFollowedCollection: () => dispatch(fetchFollowedCollection()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  updateQR: (val) => dispatch(setQR(val)),
  updateMute: (val) => dispatch(setMute(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app,
  };
}, mapDispatchToProps)(Pair);
